import { Form, Select } from "antd";
import UserSelectOption from "common/components/userSelect/userSelect";
import { customUserHandleSearch } from "utilities/generalUtility";
import { LabeledField } from "../labeledField/labeledField";

const { Option } = Select;

export const JobRecruiterField = ({
  users = [],
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const renderField = () => (
    <Select
      showArrow
      allowClear
      showSearch
      mode="multiple"
      optionFilterProp="children"
      optionLabelProp="title"
      placeholder="Select Job Recruiter(s)"
      filterOption={customUserHandleSearch}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      disabled={disabled}
      style={style}
    >
      {users.map(({ id, name, email, clients }) => (
        <Option key={id} value={id} title={name}>
          <UserSelectOption userEmail={email} clients={clients}>
            {name}
          </UserSelectOption>
        </Option>
      ))}
    </Select>
  );

  if (isFormItem) {
    return (
      <Form.Item
        label="Job Recruiter(s)"
        name="jobRecruiters"
        rules={[
          {
            required: true,
            message: "Please select job recruiter(s)",
          },
        ]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="Job Recruiter(s)" required extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
